<template>
  <div
    class="dots-card"
    ref="refRoot"
    :class="`dots-card-${props.id}`"
  >
    <div class="bottom-mask" />
  </div>
</template>

<script setup lang="ts">
const props = defineProps({
  id: {
    type: String,
    required: true,
  },
})

const emits = defineEmits([])

const { $gsap, $ScrollTrigger } = useNuxtApp()

const { app, debug, browser } = useStores()

const refRoot = ref(null)

onMounted(async () => {
  await nextTick()
  app.addCard(props.id)
})

onBeforeUnmount(() => {
  app.removeCard(props.id)
})

const flkty = inject("flkty")
watch(
  () => refRoot.value,
  () => {
    if (!refRoot.value) return
    refRoot.value.flkty = flkty
  },
  { immediate: true }
)
</script>

<style lang="scss" scoped>
@import "@/styles/shared.scss";

.dots-card {
  @include fill;
  border: 1px solid rgba($cl-light, 0.15);
  // border: 1px solid white;
  border-radius: 1.4rem;

  box-shadow: inset 0px 0px 2rem 2rem rgba(0, 0, 0, 0.9);

  // transition: transform 0.2s ease 0s;

  // transform: scale(1.1);
  // border: 10px solid red;
}

.bottom-mask {
  // @include backdropGradientBlur;
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 50%;
  backdrop-filter: blur(3px);

  --mask: linear-gradient(to bottom, rgba(0, 0, 0, 0) 0%, black 50%);
  mask-image: var(--mask);
  -webkit-mask-image: var(--mask);
}
</style>
